import { render, staticRenderFns } from "./CreateEditNode.vue?vue&type=template&id=2b239ff0"
import script from "./CreateEditNode.vue?vue&type=script&lang=js"
export * from "./CreateEditNode.vue?vue&type=script&lang=js"
import style0 from "./CreateEditNode.vue?vue&type=style&index=0&id=2b239ff0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports